import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=35a9e78c&scoped=true&"
import script from "./StatsView.vue?vue&type=script&lang=js&"
export * from "./StatsView.vue?vue&type=script&lang=js&"
import style0 from "./StatsView.vue?vue&type=style&index=0&id=35a9e78c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a9e78c",
  null
  
)

export default component.exports